import * as React from 'react'

export const Loader = () => {
    return (
        <div className="loader-spinner">
            <div class="loader-spinner-lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export const LoaderHeader = () => {
    return (
        <div className="loader-spinner-header">
            <div class="loader-spinner-lds-ring-header">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}